import {createApi} from '@reduxjs/toolkit/dist/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {
    CreateCustomInvoiceItemRequest,
    CustomInvoiceItemDTO,
    CustomInvoiceItemsListRequest,
    DeleteCustomInvoiceItemRequest,
    UpdateCustomInvoiceItemArgs,
} from 'src/types/customInvoiceItems';
import {getBaseURL} from 'src/utils/helper';

export const customInvoiceItemsApi = createApi({
    reducerPath: 'customInvoiceItemsApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/custom_invoice_items'),
    }),
    tagTypes: ['CustomInvoiceItem'],
    endpoints: (build) => {
        return {
            getCustomInvoiceItems: build.query<CustomInvoiceItemDTO[], CustomInvoiceItemsListRequest>({
                query: (params) => ({url: '', method: 'get', params}),
                providesTags: ['CustomInvoiceItem'],
            }),
            createCustomInvoiceItem: build.mutation<CustomInvoiceItemDTO, CreateCustomInvoiceItemRequest>({
                query: (data) => ({url: '', method: 'post', data}),
                invalidatesTags: ['CustomInvoiceItem'],
            }),
            updateCustomInvoiceItem: build.mutation<CustomInvoiceItemDTO, UpdateCustomInvoiceItemArgs>({
                query: ({id, data}) => ({url: `/${id}`, method: 'put', data}),
                invalidatesTags: ['CustomInvoiceItem'],
            }),
            deleteCustomInvoiceItem: build.mutation<void, DeleteCustomInvoiceItemRequest>({
                query: ({id, businessId}) => ({
                    url: `/${id}`,
                    method: 'delete',
                    params: {businessId},
                }),
                invalidatesTags: ['CustomInvoiceItem'],
            }),
        };
    },
});
